<div class="agpr-labelSpacing">
    <label id="bulkActionFormSingleTag_autocompleteLabel">
        {{ 'Tags.tags' | localize }}
        <span class="agpr-labelSpacing-required" aria-hidden="true"> * </span>
    </label>
    <span
        role="img"
        class="agpr-infoIconStyle fa-regular fa-circle-info"
        agprTooltip="Tags.info"
    ></span>
</div>
<agpr-autocomplete
    [id]="'bulkAction.removeTags.tagSelector'"
    labelField="name"
    placeholder="Tags.inputPlaceholder"
    [dropdown]="true"
    ariaLabelledBy="bulkActionFormSingleTag_autocompleteLabel"
    [(ngModel)]="selectedTag"
    (itemSelected)="selectTag($event)"
    [suggestions]="tagList$"
    [clearOnBlur]="false"
    [multiSelection]="false"
    [required]="true"
></agpr-autocomplete>
